import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const TermsOfService: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Terms of Service
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" paragraph>
        Last Updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          1. Acceptance of Terms
        </Typography>
        <Typography paragraph>
          By accessing and using Shua, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by these terms, please do not use this service.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          2. Description of Service
        </Typography>
        <Typography paragraph>
          Shua provides a platform for users to discover, organize, and participate in local sports and activities. We reserve the right to modify, suspend, or discontinue the service at any time without notice.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          3. User Conduct
        </Typography>
        <Typography paragraph>
          You agree to use the service only for lawful purposes. You are prohibited from:
        </Typography>
        <ul>
          <li><Typography paragraph>Harassing, abusing, or harming another person.</Typography></li>
          <li><Typography paragraph>Impersonating any person or entity.</Typography></li>
          <li><Typography paragraph>Interfering with or disrupting the service or servers.</Typography></li>
          <li><Typography paragraph>Posting content that is illegal, offensive, or violates the rights of others.</Typography></li>
        </ul>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          4. Account Responsibilities
        </Typography>
        <Typography paragraph>
          You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          5. Limitation of Liability
        </Typography>
        <Typography paragraph>
          Shua acts as a platform to connect users. We are not responsible for the actions of users offline, the safety of events organized through the platform, or any injuries or damages that may occur during such events. Participate at your own risk.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          6. Changes to Terms
        </Typography>
        <Typography paragraph>
          We reserve the right to modify these terms from time to time at our sole discretion. Your continued use of the site after any such changes constitutes your acceptance of the new Terms of Service.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mt: 4 }}>
          7. Contact Information
        </Typography>
        <Typography paragraph>
          If you have any questions about these Terms, please contact us at support@shua.com.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService;
